module.exports = __webpack_public_path__ + "static/media/lessonslearnt.0ea0d794.jpg";